import { reduce, pathOr } from 'ramda';
import { noop } from 'lodash';

import { SET_REFUND_DATA } from '../../register/summary/constants';
import { READY_TO_REFUND, SELECT_READER_CANCEL } from '../../register/webReader/constants';
import {
  CAPTURE_REFUND,
  READER_REFUND_FAIL,
  CANCEL_TRANSACTION,
  READER_REFUND_SUCCESS,
} from '../../terminal/constants';
import * as paymentActions from '../../register/payment/actions';
import { refundSale, refundCustomCharge } from '../../register/summary/actions';
import { refundAppointment } from '../../main/appointments/actions';
import { refundSuccess, refundFail } from '../../terminal/actions';

const refundMiddleware = (store) => {
  let sale = null;
  let shop = null;
  let amount = null;
  let refundOptions = null;
  let callback = noop;

  return next => (action) => {
    next(action);

    switch (action.type) {
      case SET_REFUND_DATA:
        sale = action.payload.sale;
        shop = action.payload.shop;
        amount = action.payload.options.amount;
        refundOptions = action.payload.options;
        callback = action.callback;

        if (amount === undefined) {
          amount = reduce(
            (memo, payment) => memo + payment.tipAmount,
            0,
            pathOr([], ['options', 'payments'], action.payload),
          );
        }
        break;
      case READER_REFUND_FAIL:
      case CANCEL_TRANSACTION:
      case SELECT_READER_CANCEL:
      case READER_REFUND_SUCCESS:
        sale = null;
        shop = null;
        amount = null;
        refundOptions = null;
        callback = noop;
        break;
      case READY_TO_REFUND:
        store.dispatch(paymentActions.createWebreaderTransaction({ chargeId: sale.chargeId, amount }, 'refund'));
        break;
      case CAPTURE_REFUND: {
        let promise = null;
        switch (sale.type) {
          case 'sale':
            promise = refundSale(shop, sale.id, refundOptions)(store.dispatch);
            break;
          case 'appointment':
            promise = refundAppointment(sale.id, refundOptions)(store.dispatch);
            break;
          default:
            promise = refundCustomCharge(shop, sale.id)(store.dispatch);
            break;
        }

        promise.then((data) => {
          callback();
          store.dispatch(refundSuccess(data, 'refund'));
        }).catch((err) => {
          store.dispatch(refundFail(err, 'refund'));
        });
        break;
      }
      default:
    }
  };
};

export default refundMiddleware;
